import { Star } from "lucide-react";

// Kompakter Social-Proof direkt am Preis/CTA: Google-Sterne + Mini-Zitat.
export const TrustInline = ({ compact = false, testId = "trust-inline" }) => (
  <div data-testid={testId} className="flex flex-col gap-1.5">
    <div className="flex items-center gap-2">
      <span className="flex gap-0.5">
        {Array.from({ length: 5 }).map((_, i) => (
          <Star key={i} className="h-3.5 w-3.5 fill-[#FBBC04] text-[#FBBC04]" strokeWidth={1} />
        ))}
      </span>
      <span className="text-[12.5px] font-semibold text-sand-800">4,8 bei Google</span>
      <span className="text-[12px] text-sand-500">· 183 Rezensionen</span>
    </div>
    {!compact && (
      <p className="text-[12.5px] text-sand-600 italic leading-snug max-w-sm">
        „Hervorragend betreut – viel Material, jederzeit erreichbar und sicher durch die
        Prüfung gebracht." <span className="not-italic text-sand-500">— Tatjana S., Google</span>
      </p>
    )}
  </div>
);
